class GlobalObject {
    static #instance = null;

    static getInstance() {
        if (GlobalObject.#instance instanceof GlobalObject) {
            return GlobalObject.#instance;
        }

        return (GlobalObject.#instance = new GlobalObject());
    }

    define (propertyKey, attributes) {
        return Reflect.defineProperty(this, propertyKey, attributes);
    }

    get (propertyKey) {
        if (!this.hasOwnProperty(propertyKey))
            return null;

        return this[propertyKey];
    }

    delete (propertyKey) {
        return Reflect.deleteProperty(this, propertyKey);
    }
}

export default GlobalObject;